import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-55" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-56" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-57" data-mp="32m1bayt2r0om">
          THE AUTONOMOUS CHILD VISUAL SYSTEM<span className="align-super text-xs" data-id="element-58" data-mp="36n3cvmagrotr">™</span>
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/bqxKxkRdjDMPMaGb8WZTVW/ChatGPT_Image_23_sept_2026,_13_31_46.webp" alt="A child looking at his completed visual morning routine — My Routine by Sigma Smart" width={1568} height={882} loading="lazy" className="mx-auto mt-5 aspect-[16/9] w-full max-w-2xl rounded-2xl border border-grape/15 object-cover shadow-[0_18px_40px_-28px_rgba(7,35,26,0.45)]" data-id="element-59" data-mp="3ufjw405xtmun" />
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-60" data-mp="29xm1cqosv8k5">
          Create a personalized visual routine for morning, afternoon and bedtime, and accompany
          each activity step by step. Stop managing your child's day — start guiding them to manage
          it themselves.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-61" data-mp="3gck196cnssoa">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-62" data-mp="3v5dhwv3o3euj">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-63" data-mp="81pddd69wn6q" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="https://instagram.com/sigmasmart.en" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-64" data-mp="335trjf5jnhj">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-65" data-mp="cu0h6r44wt4k" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-blush" data-id="element-66" data-mp="qt015lgpcjue">
          🧩 “One thing at a time.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-67" data-mp="mthjqzo3aqwb">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-68" data-mp="two2jpj5v957">
            Terms & Conditions
          </a>
          <span data-id="element-69" data-mp="13tammc3nxw66">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-70" data-mp="13sr2coqjivoz">
            Privacy Policy
          </a>
          <span data-id="element-71" data-mp="18kskuseaxing">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-72" data-mp="18m3q6wneaygo">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-73" data-mp="1hk5y7w5jqrdg">
          © 2026 SIGMA SMART™ · All rights reserved. The Autonomous Child Visual System™ is a
          digital educational product. It is not a substitute for professional psychological or
          medical advice.
        </p>
      </div>
    </footer>;
}